import { useEffect, useState } from 'react';

import { Flex } from '@revenuemarket/cds';
import { Search } from '@revenuemarket/ui/antd/Input';
import { DatePicker, Segmented } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

import { CashFlowType } from '~models/cashFlow';
import { TaxInvoiceType } from '~models/tax-invoice';

import MappingTaxInvoiceListTable from './MappingTaxInvoiceListTable';

interface Props {
  cashFlowType: CashFlowType;
  transactionAt?: string;
}

const MappingTaxInvoiceList: React.FC<Props> = ({ cashFlowType, transactionAt }) => {
  const [page, setPage] = useState(0);
  const [taxInvoiceType, setTaxInvoiceType] = useState<TaxInvoiceType>('SALES');
  const [rangeDateValue, setRangeDateValue] = useState<[Dayjs, Dayjs]>([
    dayjs(transactionAt).subtract(2, 'M').startOf('month'),
    dayjs(transactionAt).add(2, 'M').endOf('month'),
  ]);

  const [searchParam, setSearchParam] = useState<string>('');

  useEffect(() => {
    if (cashFlowType === CashFlowType.IN) {
      setTaxInvoiceType('SALES');
    } else {
      setTaxInvoiceType('PURCHASE');
    }
  }, [cashFlowType]);

  useEffect(() => {
    if (transactionAt) {
      setRangeDateValue([
        dayjs(transactionAt).subtract(2, 'M').startOf('month'),
        dayjs(transactionAt).add(2, 'M').endOf('month'),
      ]);
    }
  }, [transactionAt]);

  return (
    <Flex
      direction="column"
      style={{
        marginTop: 16,
      }}
    >
      <Flex gap={8} align="center" style={{ marginBottom: 16 }}>
        <DatePicker.RangePicker
          picker="month"
          value={rangeDateValue}
          onChange={(value) => {
            if (value && value[0] && value[1]) {
              setRangeDateValue([value[0].startOf('month'), value[1].endOf('month')] as [
                Dayjs,
                Dayjs,
              ]);
            }
          }}
        />
        <Segmented
          value={taxInvoiceType}
          onChange={(value) => {
            setPage(0);
            setTaxInvoiceType(value as TaxInvoiceType);
          }}
          options={[
            { label: '매출', value: 'SALES' },
            { label: '매입', value: 'PURCHASE' },
          ]}
        />
        <Search
          placeholder="금액, 대표 품목, 거래처, 대표자명 검색"
          style={{
            width: 590,
          }}
          onSearchChange={(value) => {
            if (page !== 0) {
              setPage(0);
            }
            setSearchParam(value);
          }}
        />
      </Flex>
      <MappingTaxInvoiceListTable
        page={page}
        setPage={setPage}
        startDate={rangeDateValue[0]}
        endDate={rangeDateValue[1]}
        type={taxInvoiceType}
        searchParam={searchParam}
      />
    </Flex>
  );
};

export default MappingTaxInvoiceList;
